import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotpasswordComponent } from './forgot-password/forgotpassword.component';
import { ResetpwdComponent } from './resetpwd/resetpwd.component';
import { DashboardLayoutComponent } from 'src/app/dashboard-layout/dashboard-layout.component';
import { AuthLayoutComponent } from 'src/app/auth-layout/auth-layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardPrincipalComponent } from './dashboard-principal/dashboard.component';
import { DashboardTeacherComponent } from './dashboard-teacher/dashboard.component';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { DashboardAreaComponent } from './dashboard-area/dashboard-area.component';
import { AuthGuard } from './_helpers/auth.guard';
import { FirsttimeloginComponent } from './first-time-login/firsttimelogin.component';
import { AntilogoutGuard } from './_helpers/antilogout.guard';
import { Role } from './_helpers/roles';
import { GT_SHELL_ROUTE_ROLES } from './_helpers/gt-shell-roles.util';
import { LandingComponent } from 'src/app/landing/landing.component';
import { DocumentsComponent } from './documents/documents.component';
import { PARA_SHELL_ROUTES } from '@para/shell/para-routes';

const routes: Routes = [
	{
		path: '',
		redirectTo: '/login',
		pathMatch: 'full',
	},
	...PARA_SHELL_ROUTES,
	{
		path: '',
		canActivate: [AuthGuard],
		component: DashboardLayoutComponent,
		children: [
			{
				path: 'landing',
				component: LandingComponent,
				data: {
					roles: [...GT_SHELL_ROUTE_ROLES],
				},
			},
			{
				path: 'resources',
				component: DocumentsComponent,
				data: {
					roles: [...GT_SHELL_ROUTE_ROLES],
				},
			},
			{
				path: 'dashboard',
				component: DashboardComponent,
				data: {
					roles: [...GT_SHELL_ROUTE_ROLES],
				},
			},
			{
				path: 'principal',
				component: DashboardPrincipalComponent,
				data: { roles: [Role.Principal] },
			},
			{
				path: 'documents',
				component: DocumentsComponent,
				data: { roles: [...GT_SHELL_ROUTE_ROLES] },
			},
			{
				path: 'teacher',
				component: DashboardTeacherComponent,
				data: { roles: [Role.Teacher] },
			},
			{
				path: 'admin',
				component: DashboardAdminComponent,
				data: { roles: [Role.Admin] },
			},
			{
				path: 'admin-lite',
				component: DashboardAdminComponent,
				data: { roles: [Role.AdminLite, Role.Admin] },
			},
			{
				path: 'area',
				component: DashboardAreaComponent,
				data: { roles: [Role.Area] },
			},
		],
	},
	{
		path: '',
		component: AuthLayoutComponent,
		children: [
			{
				path: 'login',
				component: LoginComponent,
			},
			{
				path: 'forgotpassword',
				component: ForgotpasswordComponent,
				canActivate: [AntilogoutGuard],
			},
			{
				path: 'firsttimelogin',
				component: FirsttimeloginComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'resetpwd',
				component: ResetpwdComponent,
				canActivate: [AntilogoutGuard],
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: [],
})
export class AppRoutingModule {}
